"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.devices = void 0;
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/web.dom-collections.iterator.js");
var types = _interopRequireWildcard(require("../types/devices"));
var _paulCorePackage = require("paul-core-package");
var _function = require("../../utils/function");
var _constants = require("../../utils/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const initialState = {
  errors: [],
  data: {
    buildings: [],
    allBuildings: [],
    activeBuilding: null,
    activeGroupByChartId: {},
    allPwhCByHtgSys: {},
    // {[id]: component, ...}
    activeStructure: {
      HtgSys: {},
      HtgHx: {},
      HtgCc: {},
      HtgPipe: {},
      PwhSupply: {},
      PwcPoe: {},
      PwhC: {},
      PwcPipe: {}
    },
    structure: {},
    // {HtgSys: [ component, ... ], ...} -
    devices: {
      byId: {},
      // {[id]: device, ...}
      byPwhC: [] // [d_id, ...]
    },

    values: {
      byId: {} // {[id]: value, ...}
    },

    devicesForChartRequest: _constants.keysForGroupCharts.reduce((acc, key) => _objectSpread(_objectSpread({}, acc), {}, {
      [key]: {}
    }), {}),
    alarmItem: null,
    hasData: false
  }
};

/**
 @todo: refactor reducers. All reducers should be 'pure functions'. All calculations should be inside sagas.
 **/

const devices = exports.devices = function devices() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let {
    type,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  const {
    payload: listenPayload = {},
    result: listenResult = {}
  } = payload || {};
  switch (type) {
    case types.SET_INITIAL_DEVICE_DATA:
    case _paulCorePackage.listenerTypes.GET_DEVICES_LISTENER:
      {
        var _listenResult$devices, _listenResult$devices2;
        const devicesById = ((_listenResult$devices = listenResult.devices) === null || _listenResult$devices === void 0 ? void 0 : _listenResult$devices.byId) || initialState.data.devices.byId;
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, {
            activeBuilding: null,
            structure: listenResult.structure,
            allBuildings: listenResult.allBuildings,
            buildings: listenResult.buildings,
            devices: {
              byId: devicesById,
              byPwhC: ((_listenResult$devices2 = listenResult.devices) === null || _listenResult$devices2 === void 0 ? void 0 : _listenResult$devices2.byPwhC) || initialState.data.devices.byPwhC
            },
            hasData: true
          })
        });
      }
    case types.SET_ACTIVE_BUILDING:
      {
        const structure = _paulCorePackage.functions.getCurrentStructure({
          structure: state.data.structure,
          buildingId: payload
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, {
            activeBuilding: payload,
            activeStructure: structure,
            allPwhCByHtgSys: structure.byHtgSys.PwhC,
            devices: _objectSpread(_objectSpread({}, state.data.devices), {}, {
              byPwhC: Object.values(structure.active).reduce((acc, g) => [...acc, ...(Object.values(g) || []).reduce((accC, c) => [...accC, ...c.devicesId], [])], [])
            })
          })
        });
      }
    case types.SET_ACTIVE_GROUP:
      {
        var _state$data$structure;
        const {
          chartId,
          equipmentKey,
          building,
          group = {}
        } = payload;
        const equipmentKeyIsPwh = equipmentKey === _constants.keysForGroupChartsById.Pwh;
        const activePwhCId = equipmentKeyIsPwh ? group.id || Object.keys(((_state$data$structure = state.data.structure) === null || _state$data$structure === void 0 ? void 0 : _state$data$structure.PwhC) || {})[0] : null;
        const structure = _paulCorePackage.functions.getCurrentStructure({
          structure: state.data.structure,
          buildingId: state.data.activeBuilding,
          activePwhC: activePwhCId
        });
        const activeHtgHxId = !equipmentKeyIsPwh ? group.id || Object.keys(structure.active.HtgHx)[0] : null;
        const structureWithCalcHtgHx = _paulCorePackage.functions.getCurrentStructureWithHtgHx({
          structure,
          activeHtgHx: activeHtgHxId
        });
        const {
          active: activeStructure
        } = structureWithCalcHtgHx || {};
        const devicesById = state.data.devices.byId;
        const activeGroupId = equipmentKeyIsPwh ? activePwhCId : activeHtgHxId;
        const devicesForChartRequest = (0, _function.calculateDevicesForChartRequest)({
          activeStructure: structureWithCalcHtgHx.active,
          devicesById,
          key: equipmentKey
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, {
            activeStructure: structureWithCalcHtgHx,
            devices: _objectSpread(_objectSpread({}, state.data.devices), {}, {
              byPwhC: Object.values(activeStructure).reduce((acc, g) => {
                const valuesG = Object.values(g) || [];
                return [...acc, ...valuesG.reduce((accC, c) => {
                  const devicesId = (c === null || c === void 0 ? void 0 : c.devicesId) || [];
                  return [...accC, ...devicesId];
                }, [])];
              }, [])
            }),
            activeGroupByChartId: _objectSpread(_objectSpread({}, state.data.activeGroupByChartId), {}, {
              [chartId]: activeGroupId || null
            }),
            devicesForChartRequest: _objectSpread(_objectSpread({}, state.data.devicesForChartRequest), {}, {
              [equipmentKey]: _objectSpread(_objectSpread({}, state.data.devicesForChartRequest[equipmentKey] || {}), {}, {
                [chartId]: devicesForChartRequest || {}
              })
            })
          })
        });
      }
    case types.SET_ACTIVE_PWH_C:
      const structure = _paulCorePackage.functions.getCurrentStructure({
        structure: state.data.structure,
        buildingId: state.data.activeBuilding,
        activePwhC: payload
      });
      // console.log('activePwhC', structure)
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          // activePwhC: payload,
          activeStructure: structure.active,
          allPwhCByHtgSys: structure.byHtgSys.PwhC,
          devices: _objectSpread(_objectSpread({}, state.data.devices), {}, {
            byPwhC: Object.values(structure.active).reduce((acc, g) => [...acc, ...(Object.values(g) || []).reduce((accC, c) => [...accC, ...c.devicesId], [])], [])
          })
        })
      });
    case types.SET_ALARM_ITEM:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          alarmItem: _objectSpread(_objectSpread({}, state), {}, {
            [payload.chartId]: payload.alarmItem
          })
        });
      }
    case types.RESET_ALL:
      return initialState;
    default:
      return state;
  }
};